export default {
  form: {
    first_name: {
      label: 'Voornaam',
    },
    last_name: {
      label: 'Achternaam',
    },
    email: {
      label: 'E-mail',
    },
    phone_number: {
      label: 'Telefoonnummer',
    },
    birthday: {
      label: 'Geboortedatum',
    },
    city: {
      label: 'Stad',
    },
  },
  buttons: {
    save: 'Opslaan',
  },
  toasts: {
    success: 'Profiel succesvol bijgewerkt',
    error: 'Profiel bijwerken mislukt',
  },
};
